
import { Component, Prop, Vue, TSX } from 'vue-facing-decorator'
import { FORM_TYPE_LIST, FORM_WEEK_LIST, FORM_DATE_TYPE, DEFAULT_INTERVAL, isOptionType } from './form-type'
interface Props {
  modelValue?: any
}
@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop()
  modelValue: any;

  typeList = FORM_TYPE_LIST;
  weekList = FORM_WEEK_LIST;

  form: any = {
    name: '',
    placeholder: '',
    type: 1,
    isRequire: 0,
    isEnabled: 1,
    content: null,
  }

  get isOptionType() {
    return isOptionType(this.form.type);
  }

  get isDateType() {
    return this.form.type == FORM_DATE_TYPE;
  }

  get optionList() {
    return this.form.content?.list || [];
  }

  created() {
    let row = this.modelValue || {};
    let type = row.type || 1;
    this.form = {
      name: row.name || '',
      placeholder: row.placeholder || '',
      type,
      // 用 == 归一化，兼容后端把 tinyint 传成字符串
      isRequire: row.isRequire == 1 ? 1 : 0,
      isEnabled: row.isEnabled == 1 ? 1 : 0,
      content: this.buildContent(type, row.content),
    };
  }

  /** 与列表里的联动保持一致：必填就必须启用 */
  changeRequire(val) {
    this.form.isRequire = val;
    if (val == 1) this.form.isEnabled = 1;
  }

  /** 不启用就不能必填 */
  changeEnabled(val) {
    this.form.isEnabled = val;
    if (val == 0) this.form.isRequire = 0;
  }

  /**
   * 单选/多选要选项列表，时间预约要星期 + 时间范围，
   * 其余类型不需要 content，置空避免残留之前类型的配置
   */
  buildContent(type, content) {
    content = content || {};
    if (isOptionType(type)) {
      let list = (content.list || []).map((item) => {
        return { name: item.name, value: item.value };
      });
      return { list: list.length ? list : [{ name: '', value: '' }] };
    }
    if (type == FORM_DATE_TYPE) {
      return {
        weekDays: content.weekDays || [],
        startTime: content.startTime || '',
        endTime: content.endTime || '',
        interval: content.interval || DEFAULT_INTERVAL,
      };
    }
    return null;
  }

  changeType(type) {
    this.form.content = this.buildContent(type, null);
  }

  addOption() {
    this.form.content.list.push({ name: '', value: '' });
  }

  removeOption(index) {
    this.form.content.list.splice(index, 1);
  }

  submitForm() {
    if (!this.form.name) return this.$error('请输入字段名称');
    let content = null;
    if (this.isOptionType) {
      let list = this.optionList.filter((item) => item.name || item.value);
      if (!list.length) return this.$error('请至少添加一个选项');
      if (list.some((item) => !item.name || !item.value)) {
        return this.$error('选项名称和选项值都要填写');
      }
      content = { list };
    } else if (this.isDateType) {
      let { weekDays, startTime, endTime, interval } = this.form.content;
      if (!weekDays || !weekDays.length) return this.$error('请选择可预约的星期');
      if (!startTime || !endTime) return this.$error('请选择可约时间范围');
      // 'HH:mm' 定长零填充，字符串比较等价于时间先后
      if (startTime >= endTime) return this.$error('开始时间要早于结束时间');
      if (!interval || interval < 1) return this.$error('请填写大于 0 的间隔分钟数');
      content = { weekDays, startTime, endTime, interval };
    }
    this.$emit('resolve', {
      ...this.modelValue,
      name: this.form.name,
      placeholder: this.form.placeholder,
      type: this.form.type,
      isRequire: this.form.isRequire,
      isEnabled: this.form.isEnabled,
      content,
    });
  }
}
